import React from 'react';
import PropTypes from 'prop-types';

import Footer from './shared/Footer';

const NotFound = ({ partial }) => {
	// If we don't need the whole page
	if (partial === true) {
		return (
			<h1>404 - Not Found</h1>
		);
	}

	return (
		<div className="page">
			<div className="content" id="content">
				<div className="section">
					<h1>404 - Not Found</h1>
				</div>
				<Footer />
			</div>
		</div>
	);
};

NotFound.propTypes = {
	partial: PropTypes.bool
};

export default NotFound;


// WEBPACK FOOTER //
// ./src/components/NotFound.js